<app-iota-modal i18n-title title="Add license pricing" [modalOptions]="modalOptions" (close$)="closeDialog()">
    <div modal-body class="w-full">
        <app-platform-license-pricing-form
            [platformLicense]="data?.platformLicense"
            [editMode]="true"
            (formValid)="updateFormValidity($event)"
            #platformLicensePricingForm
        ></app-platform-license-pricing-form>
    </div>

    <ng-container modal-footer>
        <div class="w-full flex flex-row items-center justify-between gap-5">
            <button class="btn btn-sm btn-ghost rounded-full flex flex-row items-center gap-2" (click)="closeDialog()">
                <span i18n>Cancel</span>
            </button>

            <button
                class="btn btn-sm btn-primary rounded-full flex flex-row items-center gap-2"
                [ngClass]="{ loading: loading$ | ngrxPush }"
                [disabled]="!formValid"
                (click)="save()"
            >
                <span i18n>Save</span>
            </button>
        </div>
    </ng-container>
</app-iota-modal>
